defer('jQuery', () => {
  $(document).ready(function () {
    var pInfScrLoading = false;
    var pInfScrDelay = 250;

    function pInfScrExecute() {
      let pInfScrNode = $(".more").last();
      let pInfScrURL = $(".more .RoundButton").last().attr("data-url");
      if (pInfScrNode.length > 0 && pInfScrNode.css("display") != "none") {
        $.ajax({
          type: "GET",
          url: pInfScrURL,
          beforeSend: function () {
            pInfScrLoading = true;
            pInfScrNode.addClass("loading");
          },
          success: function (data) {
            // remove loading feedback
            pInfScrNode.parent().remove();
            var filteredData = $(data).find(".teaser-product").addClass("load");
            $(".teaser-product").append(filteredData);
            if ($(data).find(".more").length > 0) {
              setTimeout(function () {
                $(".teaser-product").removeClass("load").addClass("loaded");
              }, 200);
            }
            setTimeout(function () {
              $(".Grid__Cell").removeClass("load").addClass("loaded");
            }, 200);
            pInfScrLoading = false;
            $(".top").show();
            attachClickEvent();
          },
          dataType: "html",
        });
      }
    }

    function attachClickEvent() {
      $(".more .RoundButton").click(function (event) {
        pInfScrExecute();
        event.stopPropagation();
        return false;
      });
    }
    attachClickEvent();

    // responsive title swapping
    (function () {

      $(".toggle-collapse").on("click", function () {
        $("#collection-description")
          .toggleClass("collapsed-mobile")
          .toggleClass("expanded-mobile");

        let btn = $(this);

        if ($("#collection-description").hasClass("expanded-mobile")) {
          setTimeout(function () {
            btn.text(btn.data("text-less"));
          }, 1000);
        } else {
          setTimeout(function () {
            btn.text(btn.data("text-more"));
          }, 1000);
        }
      });

      $("#collection-description").attr('style',`--section-height: ${$("#collection-description").height()}px`);
    })();
  });
});
